import React, { useState } from "react";
import {
  Tabs,
  IconButton,
  ComepetencyCard,
  UpgradeCard,
  ErrorMessage,
} from "../../../components";
import { connect } from "react-redux";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  tabsData,
  CompetenciesFields,
  FutureFocusData,
  ThingsDoneData,
  CognitiveData,
  aptitudeData,
  WorkingWithOthers,
  leadingOthers,
  selfMastery,
  defaultHintMessage,
} from "./data";
import { toAbsoluteUrl } from "../../../services";
import { useSelector } from "react-redux";
import {
  FaChevronLeft,
  FaChevronRight,
  FaAngleRight,
  FaAngleLeft,
} from "react-icons/fa";
import "./main.css";
import {
  chooseAssessment,
  previousStep,
} from "../../../redux/actions/free/homeActions";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HelpButton from "../../../components/button/helpButton";


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        marginRight: "-10px",
        marginTop: "-30px",
        width: "30px",
        height: "30px",
        borderRadius: "100%",
        backgroundColor: "#007E8C",
        display: "flex",
        justifyItems: "center",
        alignItems: "center",
      }}
      onClick={onClick}
    >
      <FaChevronRight className="h-4 w-4 mx-auto text-white rounded-full" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        marginLeft: "-10px",
        marginTop: "-30px",
        width: "30px",
        height: "30px",
        borderRadius: "100%",
        backgroundColor: "#007E8C",
        display: "flex",
        justifyItems: "center",
        alignItems: "center",
      }}
      onClick={onClick}
    >
      <FaChevronLeft className="h-4 w-4 mx-auto text-white rounded-full" />
    </div>
  );
}

const sliderSettings = {
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 300,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

// get step data from redux main state
const data = (state) => state.home.step2Data;

let ChooseAssessment = (props) => {
  // savedData
  let savedData = useSelector(data);
  var isEmpty = Object.entries(savedData).length > 0;
  const [upgrade, setUpgrade] = useState(false);
  const [limitError, setlimitError] = useState(false);
  const [competenciesSelectedData, setCompetenciesData] = useState(
    isEmpty === true ? savedData.competenciesSelectedData : []
  );
  const [cognitiveSelectedData, setCognitiveData] = useState(
    isEmpty === true ? savedData.cognitiveSelectedData : []
  );
  const [aptitudeSelectedData, setAptitudeData] = useState(
    isEmpty === true ? savedData.aptitudeSelectedData : []
  );

  // Tab State Start
  const [activeTab, setActiveTab] = useState(0);
  // Tab State End

  // Nested Tab Handler State
  const [selectedTab, setSelectedTab] = useState(0);

  // Errors
  const [error, setError] = useState(false);

  // item name for visible data on hover
  const [competencyName, setCompetencyName] = useState("");
  const [cognitivename, setCognitiveName] = useState("");
  const [aptitudeName, setAptitudeName] = useState("");

  // total Bucket Length
  const [totalBucketLength, setTotalBucketLength] = useState(
    isEmpty === true
      ? savedData.competenciesBucket.length +
      savedData.cognitiveBucket.length +
      savedData.aptitudeBucket.length
      : 0
  );

  const [competenciesBucket, setCompetenciesBucket] = useState(
    isEmpty === true ? savedData.competenciesBucket : []
  );

  const [cognitiveBucket, setCongnitiveBucket] = useState(
    isEmpty === true ? savedData.cognitiveBucket : []
  );

  const [aptitudeBucket, setAptitudeBucket] = useState(
    isEmpty === true ? savedData.aptitudeBucket : []
  );

  const [hintMessage, setHintMessage] = useState(defaultHintMessage);

  //   Tab Handler
  let mainTabHandler = (event, value) => {
    setActiveTab(value);
  };

  // Handle Next Button Function
  let handleNext = () => {
    if (totalBucketLength > 4) {
      var multiDimensionArray = [
        competenciesSelectedData,
        cognitiveSelectedData,
        aptitudeSelectedData,
      ]; //array of arrays
      var allCompetencies = Array.prototype.concat.apply(
        [],
        multiDimensionArray
      ); //flatten array of arrays
      let data = {
        cognitiveBucket,
        aptitudeBucket,
        competenciesBucket,
        allCompetencies,
        competenciesSelectedData,
        cognitiveSelectedData,
        aptitudeSelectedData,
      };
      props.chooseAssessment(data, 3);
    } else {
      setError(true);
    }
  };

  let handlePrevious = () => {
    props.previousStep(1);
  };

  // Competencies

  let handleCompetenciesCard = (name, type, competency) => {
    if (totalBucketLength < 10) {
      let data = competenciesBucket;
      let alreadySelected = competenciesSelectedData;
      if (competenciesBucket.length > 0) {
        if (!competenciesBucket.includes(name)) {
          data.push(name);
          alreadySelected.push(competency);
          setTotalBucketLength(totalBucketLength + 1);
          setCompetenciesBucket([...data]);
          setCompetenciesData(alreadySelected);
          setError(false);
        }
      } else {
        let data = [];
        let competencies = [];
        data.push(name);
        competencies.push(competency);
        setCompetenciesBucket(data);
        setCompetenciesData(competencies);
        setTotalBucketLength(totalBucketLength + 1);
        setError(false);
      }
    } else {
      setlimitError(true);
    }
  };

  let removeCompetenciesBucket = (name, index) => {
    if (competenciesBucket.includes(name)) {
      competenciesBucket.splice(index, 1);
      competenciesSelectedData.splice(index, 1);
      setCompetenciesBucket([...competenciesBucket]);
      setCompetenciesData([...competenciesSelectedData]);
      setError(false);
      if (totalBucketLength > 0) {
        setTotalBucketLength(totalBucketLength - 1);
        setError(false);
      }
    }
  };

  let competenciesInfoClick = (name, bubbleDescription) => {
    setCompetencyName(name);
    setHintMessage(bubbleDescription);
  };
  let competenciesInfoHide = () => {
    setCompetencyName("");
    setHintMessage(defaultHintMessage);
  };

  // Step 1 Funtions start
  let handleCognitiveCard = (name, type, competency) => {
    if (totalBucketLength < 10) {
      let data = cognitiveBucket;
      let alreadySelectedCog = cognitiveSelectedData;
      if (cognitiveBucket.length > 0) {
        if (!cognitiveBucket.includes(name)) {
          data.push(name);
          alreadySelectedCog.push(competency);
          setTotalBucketLength(totalBucketLength + 1);
          setCongnitiveBucket([...data]);
          setCognitiveData([...alreadySelectedCog]);
          setError(false);
        }
      } else {
        let data = [];
        let cognitiveSelectd = [];
        data.push(name);
        cognitiveSelectd.push(competency);
        setCongnitiveBucket(data);
        setCognitiveData(cognitiveSelectd);
        setTotalBucketLength(totalBucketLength + 1);
        setError(false);
      }
    } else {
      setlimitError(true);
    }
  };

  let removeCognitiveBucket = (name, index) => {
    if (cognitiveBucket.includes(name)) {
      cognitiveBucket.splice(index, 1);
      cognitiveSelectedData.splice(index, 1);
      setCongnitiveBucket([...cognitiveBucket]);
      setCognitiveData([...cognitiveSelectedData]);

      setError(false);
      if (totalBucketLength > 0) {
        setTotalBucketLength(totalBucketLength - 1);
        setError(false);
      }
    }
  };

  let cognitiveInfoClick = (name, bubbleDescription) => {
    setCognitiveName(name);
    setHintMessage(bubbleDescription);
  };
  let cognitiveInfoHide = () => {
    setCognitiveName("");
    setHintMessage(defaultHintMessage);
  };

  // Step 1 Funtions End

  // Step 2 Start

  let handleAptitudeCard = (name, type, competency) => {
    if (totalBucketLength < 10) {
      let data = aptitudeBucket;
      let alreadySelectedAp = aptitudeSelectedData;
      if (aptitudeBucket.length > 0) {
        if (!aptitudeBucket.includes(name)) {
          data.push(name);
          alreadySelectedAp.push(competency);
          setTotalBucketLength(totalBucketLength + 1);
          setAptitudeData([...alreadySelectedAp]);
          setAptitudeBucket([...data]);
        }
      } else {
        let data = [];
        let selectedAp = [];
        data.push(name);
        selectedAp.push(competency);
        setAptitudeBucket(data);
        setAptitudeData(selectedAp);
        setTotalBucketLength(totalBucketLength + 1);
      }
    } else {
      setlimitError(true);
    }
  };

  let removeAptitudeBucket = (name, index) => {
    if (aptitudeBucket.includes(name)) {
      aptitudeBucket.splice(index, 1);
      aptitudeSelectedData.splice(index, 1);
      setAptitudeBucket([...aptitudeBucket]);
      setAptitudeData([...aptitudeSelectedData]);

      if (totalBucketLength > 0) {
        setTotalBucketLength(totalBucketLength - 1);
      }
    }
  };

  let aptitudeInfoClick = (name, bubbleDescription) => {
    setAptitudeName(name);
    setHintMessage(bubbleDescription);
  };
  let aptitudeInfoHide = () => {
    setAptitudeName("");
    setHintMessage(defaultHintMessage);
  };

  // update Plan

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };

  // Step 2 End

  // console.log(totalBucketLength, '=======>  total length of bucket');
  // console.log(competenciesBucket, '=======>  competenciesBucket selected');
  // console.log(cognitiveBucket, '=======>  aptitudeBucket selected');
  // console.log(aptitudeBucket, '=======>  cognitiveBucket selected');
  // console.log(aptitudeSelectedData);

  return (
    <>
      {upgrade ? (
        <UpgradeCard type="FREE" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-6/12 xl:w-7/12 lg:w-7/12 w-11/12">
          <div>
            <div className="bg-white rounded-md shadow-lg 2xl:px-10 xl:px-10 lg:px-10 px-4 py-8">
              <Tabs
                onChange={mainTabHandler}
                current={activeTab}
                data={tabsData}
              >
                {activeTab === 0 ? (
                  <div>
                    <div>
                      <div className="flex flex-row">
                        {CompetenciesFields.map((item, i) => {
                          return (
                            <div key={i}>
                              <button
                                onClick={() => setSelectedTab(i)}
                                className={`${selectedTab === i
                                  ? "bg-[#FFD700]"
                                  : "bg-[#E1E1E1]"
                                  } text-sm  px-2 py-2 rounded	mr-3`}
                              >
                                <span
                                  className={`${selectedTab === i
                                    ? "text-[#3B4345] "
                                    : "text-[#4B4141B2]"
                                    } font-bold text-xs`}
                                >
                                  {item.name}
                                </span>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    {/* SJTS START */}
                    {selectedTab === 0 ? (
                      <div className="mt-6">
                        <Slider {...sliderSettings}>
                          {FutureFocusData &&
                            FutureFocusData.map((item, index) => {
                              return (
                                <ComepetencyCard
                                  infoClick={() =>
                                    competenciesInfoClick(
                                      item.name,
                                      item.bubbleDescription
                                    )
                                  }
                                  infoHide={() => competenciesInfoHide()}
                                  name={competencyName}
                                  // disabled={
                                  //   totalBucketLength === 10 ? true : false
                                  // }
                                  selected={competenciesBucket.includes(
                                    item.name
                                  )}
                                  key={index}
                                  item={item}
                                  onAddItem={() => {
                                    handleCompetenciesCard(
                                      item.name,
                                      "competency",
                                      item.competency
                                    );
                                  }}
                                />
                              );
                            })}
                        </Slider>
                      </div>
                    ) : selectedTab === 1 ? (
                      <div className="mt-6">
                        <Slider {...sliderSettings}>
                          {ThingsDoneData &&
                            ThingsDoneData.map((item, index) => {
                              return (
                                <ComepetencyCard
                                  infoClick={() =>
                                    competenciesInfoClick(
                                      item.name,
                                      item.bubbleDescription
                                    )
                                  }
                                  infoHide={() => competenciesInfoHide()}
                                  name={competencyName}
                                  // disabled={
                                  //   totalBucketLength === 10 ? true : false
                                  // }
                                  selected={competenciesBucket.includes(
                                    item.name
                                  )}
                                  key={index}
                                  item={item}
                                  onAddItem={() => {
                                    handleCompetenciesCard(
                                      item.name,
                                      "competency",
                                      item.competency
                                    );
                                  }}
                                />
                              );
                            })}
                        </Slider>
                      </div>
                    ) : selectedTab === 2 ? (
                      <div className="mt-6">
                        <Slider {...sliderSettings}>
                          {WorkingWithOthers &&
                            WorkingWithOthers.map((item, index) => {
                              return (
                                <ComepetencyCard
                                  infoClick={() =>
                                    competenciesInfoClick(
                                      item.name,
                                      item.bubbleDescription
                                    )
                                  }
                                  infoHide={() => competenciesInfoHide()}
                                  name={competencyName}
                                  // disabled={
                                  //   totalBucketLength === 10 ? true : false
                                  // }
                                  selected={competenciesBucket.includes(
                                    item.name
                                  )}
                                  key={index}
                                  item={item}
                                  onAddItem={() => {
                                    handleCompetenciesCard(
                                      item.name,
                                      "competency",
                                      item.competency
                                    );
                                  }}
                                />
                              );
                            })}
                        </Slider>
                      </div>
                    ) : selectedTab === 3 ? (
                      <div className="mt-6">
                        <Slider {...sliderSettings}>
                          {leadingOthers &&
                            leadingOthers.map((item, index) => {
                              return (
                                <ComepetencyCard
                                  infoClick={() =>
                                    competenciesInfoClick(
                                      item.name,
                                      item.bubbleDescription
                                    )
                                  }
                                  infoHide={() => competenciesInfoHide()}
                                  name={competencyName}
                                  // disabled={
                                  //   totalBucketLength === 10 ? true : false
                                  // }
                                  selected={competenciesBucket.includes(
                                    item.name
                                  )}
                                  key={index}
                                  item={item}
                                  onAddItem={() => {
                                    handleCompetenciesCard(
                                      item.name,
                                      "competency",
                                      item.competency
                                    );
                                  }}
                                />
                              );
                            })}
                        </Slider>
                      </div>
                    ) : selectedTab === 4 ? (
                      <div className="mt-6">
                        <Slider {...sliderSettings}>
                          {selfMastery &&
                            selfMastery.map((item, index) => {
                              return (
                                <ComepetencyCard
                                  infoClick={() =>
                                    competenciesInfoClick(
                                      item.name,
                                      item.bubbleDescription
                                    )
                                  }
                                  infoHide={() => competenciesInfoHide()}
                                  name={competencyName}
                                  // disabled={
                                  //   totalBucketLength === 10 ? true : false
                                  // }
                                  selected={competenciesBucket.includes(
                                    item.name
                                  )}
                                  key={index}
                                  item={item}
                                  onAddItem={() => {
                                    handleCompetenciesCard(
                                      item.name,
                                      "competency",
                                      item.competency
                                    );
                                  }}
                                />
                              );
                            })}
                        </Slider>
                      </div>
                    ) : null}

                    {/* SJTS END */}
                  </div>
                ) : activeTab === 1 ? (
                  <div>
                    <Slider {...sliderSettings}>
                      {CognitiveData &&
                        CognitiveData.map((item, index) => {
                          return (
                            <ComepetencyCard
                              infoClick={() =>
                                cognitiveInfoClick(
                                  item.name,
                                  item.bubbleDescription
                                )
                              }
                              infoHide={() => cognitiveInfoHide()}
                              name={cognitivename}
                              // disabled={totalBucketLength === 10 ? true : false}
                              selected={cognitiveBucket.includes(item.name)}
                              key={index}
                              item={item}
                              onAddItem={() => {
                                handleCognitiveCard(
                                  item.name,
                                  "cognitive",
                                  item.competency
                                );
                              }}
                            />
                          );
                        })}
                    </Slider>
                  </div>
                ) : activeTab === 2 ? (
                  <div>
                    <Slider {...sliderSettings}>
                      {aptitudeData &&
                        aptitudeData.map((item, index) => {
                          return (
                            <ComepetencyCard
                              infoClick={() =>
                                aptitudeInfoClick(
                                  item.name,
                                  item.bubbleDescription
                                )
                              }
                              infoHide={() => aptitudeInfoHide()}
                              name={aptitudeName}
                              // disabled={totalBucketLength === 10 ? true : false}
                              selected={aptitudeBucket.includes(item.name)}
                              key={index}
                              item={item}
                              onAddItem={() => {
                                handleAptitudeCard(
                                  item.name,
                                  "aptitude",
                                  item.competency
                                );
                              }}
                            />
                          );
                        })}
                    </Slider>
                  </div>
                ) : null}
              </Tabs>

              <div>
                <p className="text-[#424444] text-xl font-semibold mb-6">
                  You need to select at least 5 assessments in total (10 Max)
                </p>
                <h3 className="text-[#007E8C] tracking-[0.12rem] font-semibold text-xl">
                  Competency Assessments{" "}
                  {`(${competenciesBucket && competenciesBucket.length})`}
                </h3>
                <div className="flex flex-row items-center mt-6">

                  <img
                    alt="Logo"
                    style={{
                      marginTop: "-12px",
                      width: "100px",
                    }}
                    src={toAbsoluteUrl(
                      competenciesBucket.length > 0
                        ? "/media/home/bucket.png"
                        : "/media/home/emptyBucket.png"
                    )}
                  />
                  <div className="ml-4 my-4">
                    <div className="flex flex-row flex-wrap">
                      {competenciesBucket &&
                        competenciesBucket.map((item, i) => {
                          return (
                            <button
                              key={i}
                              onClick={() => removeCompetenciesBucket(item, i)}
                              className="bg-[#FEBB12] mx-3 my-3 h-max py-3 px-2 hover:bg-grey text-[#424444] font-medium rounded-md flex items-center justify-center   shadow-md"
                            >
                              <span className="pr-1 text-sm text-[#424444] font-semibold ">
                                {item}
                              </span>

                              <AiOutlineCloseCircle className="text-[#424444] mt-1" />
                            </button>
                          );
                        })}
                    </div>
                  </div>
                </div>

                <h3 className="text-[#007E8C] tracking-[0.12rem] font-semibold text-xl">
                  Cognitive Ability Assessments{" "}
                  {`(${cognitiveBucket && cognitiveBucket.length})`}
                </h3>
                <div className="flex flex-row items-center mt-6">
                  <img
                    alt="Logo"
                    style={{
                      marginTop: "-12px",
                      width: "100px",
                    }}
                    src={toAbsoluteUrl(
                      cognitiveBucket.length > 0
                        ? "/media/home/bucket.png"
                        : "/media/home/emptyBucket.png"
                    )}
                  />
                  <div className="ml-4 my-4">
                    <div className="flex flex-row flex-wrap">
                      {cognitiveBucket &&
                        cognitiveBucket.map((item, i) => {
                          return (
                            <button
                              key={i}
                              onClick={() => removeCognitiveBucket(item, i)}
                              className="bg-[#FEBB12] mx-3 my-3 h-max py-3 px-2 hover:bg-grey text-[#424444] font-medium rounded-md flex items-center justify-center   shadow-md"
                            >
                              <span className="pr-1 text-sm text-[#424444] font-semibold">
                                {item}
                              </span>

                              <AiOutlineCloseCircle className="text-[#424444] mt-1" />
                            </button>
                          );
                        })}
                    </div>
                  </div>
                </div>

              </div>

              <h3 className="text-[#007E8C] tracking-[0.12rem] font-semibold text-xl">
                Aptitude Assessments{" "}
                {`(${aptitudeBucket && aptitudeBucket.length})`}
              </h3>
              <div className="flex flex-row items-center mt-6">
                <img
                  alt="Logo"
                  style={{
                    marginTop: "-12px",
                    width: "100px",
                  }}
                  src={toAbsoluteUrl(
                    aptitudeBucket.length > 0
                      ? "/media/home/bucket.png"
                      : "/media/home/emptyBucket.png"
                  )}
                />
                <div className="ml-4 my-4">
                  <div className="flex flex-row flex-wrap">
                    {aptitudeBucket &&
                      aptitudeBucket.map((item, i) => {
                        return (
                          <button
                            key={i}
                            onClick={() => removeAptitudeBucket(item, i)}
                            className="bg-[#FEBB12] mx-3 my-3 h-max py-3 px-2 hover:bg-grey text-[#424444] font-medium rounded-md flex items-center justify-center   shadow-md"
                          >
                            <span className="pr-1 text-sm text-[#424444] font-semibold ">
                              {item}
                            </span>

                            <AiOutlineCloseCircle className="text-[#424444] mt-1" />
                          </button>
                        );
                      })}
                  </div>
                </div>
              </div>


              <h3 className="text-[#007E8C] font-semibold text-sm text-right mr-5">
                Total Assessments Selected
              </h3>
              <div className={`${totalBucketLength <= 0 && 'mr-[15px]'} flex justify-end items-end mb-7`}>
                <img
                  style={{
                    height: "90px",
                  }}
                  src={`${toAbsoluteUrl("/media/home/gameIcon.png")}`}
                  alt="boy"
                />

                <p className={`${totalBucketLength <= 0 && 'hidden'} text-[#FFB700] text-5xl font-bold  relative right-3 bg-[white] p-2 rounded-full`}>
                  {totalBucketLength > 0
                    ? totalBucketLength > 9
                      ? `${totalBucketLength}`
                      : `0${totalBucketLength}`
                    : null}
                </p>
              </div>

              {limitError && totalBucketLength >= 10 ? (
                <div className="w-max mx-auto">
                  <ErrorMessage
                    onClick={() => {
                      setlimitError(false);
                    }}
                    text={"Your maximum limit has been reached."}
                  />
                </div>
              ) : null}

              {totalBucketLength <= 9 && error ? (
                <div className="w-max mx-auto">
                  <ErrorMessage
                    onClick={() => setError(false)}
                    text={" Select at least 5 assessments."}
                  />
                </div>
              ) : null}
            </div>

            <div className="2xl:absolute 2xl:right-[5rem] 2xl:top-[25rem] xl:absolute lg:absolute lg:top-[65%] lg:right-1 2xl:block xl:block lg:block hidden ">
              <img
                className="textBubble bg-contain xl:h-[16rem] lg:h-[15rem]"
                src={`${toAbsoluteUrl("/media/home/bubble.png")}`}
                alt=""
              />
              <div className="absolute flex flex-col justify-center items-center  inset-4">
                {hintMessage !== defaultHintMessage ? (
                  <p className="text-xs mt-4 text-[#131111] font-bold top-[30px]  absolute">
                    This assessment is best suited for:
                  </p>
                ) : null}

                <p className="text-xs text-[#131111] font-medium text-center mt-4">
                  {hintMessage}
                </p>
              </div>
            </div>
            <div className="2xl:right-[7rem] 2xl:top-[41rem] absolute right-10  top-[95%] 2xl:block xl:block lg:block lg:right-1 lg:top-[105%] hidden">
              <img
                style={{
                  height: "360px",
                }}
                src={`${toAbsoluteUrl("/media/home/hintBoy.png")}`}
                alt="boy"
                className="hintBoy"
              />
            </div>
          </div>

          <div className="my-10 flex justify-between ">
            <IconButton
              onClick={handlePrevious}
              name="Previous"
              customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 flex-row-reverse bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm  font-semibold  2xl:tracking-[0.1rem] xl:tracking-[0.1rem] "
            >
              <FaAngleLeft className="text-white mr-1 mt-[1px]" />
            </IconButton>

            <div className="text-center">
              <h1 className="font-medium text-xl  text-[#3B4345]">
                Your Current Plan:{" "}
                <b className="font-bold text-xl text-[#007E8C]">FREE</b>
              </h1>
              <button
                onClick={() => updatePlan()}
                className="font-medium underline text-[#007E8C] mt-2"
              >
                Upgrade Your Plan
              </button>
            </div>

            <IconButton
              onClick={handleNext}
              name="Next"
              customStyle="2xl:h-22 xl:h-22 h-12 2xl:px-10 xl:px-10 px-6 bg-[#007E8C] 2xl:text-lg xl:text-lg text-sm font-semibold  tracking-[0.1rem]"
            >
              <FaAngleRight className="text-white mt-[1px]" />
            </IconButton>
          </div>
        </div>
      )}


      <HelpButton screen="login" />
    </>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { previousStep, chooseAssessment })(
  ChooseAssessment
);
